module.exports = __webpack_public_path__ + "static/linkedin-d4322e59c32028d56dd2ebb64b0cf680.png";